import React, { useEffect, useRef, useState, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Loadable from '../components/common/lodable/Loadable';
import { useIsAuthenticated } from '@azure/msal-react';

// routes
import AuthenticatedRoutes from './AuthenticatedRoutes';
import ETrackRoutes from './ETrackRoutes';
import Login from '../pages/login/Login';
import { CUSTOMERS, USER_TYPE } from '../constants';
import useAuthorization from '../hooks/useAuthorization';
import useAuthExternalUser from '../hooks/useAuthExternalUser';
import { useSelector } from 'react-redux';
import useRouteGuard from '../hooks/useRouteGuard';
import MainLayout from '../layout/MainLayout';
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const HomePage = Loadable(lazy(() => import('../pages/home/Home')));
  const { fetchTokenAndUserData } = useAuthorization();
  const { getIsReadOnlyPermission } = useRouteGuard();
  const { externalUserDetails, getUserType } = useAuthExternalUser();
  const { userPermissions } = useSelector((state) => state.common);
  const userType = getUserType();
  const shouldLog = useRef(false);
  const LoginRoute = {
    path: '*',
    element: <Login />,
    children: [
      {
        path: '*',
        element: <Navigate to="login" />,
      },
    ],
  };
  let isAuthenticationEnabled =
    window.location.hostname.indexOf('localhost') <= -1;
  let isAuthenticated;
  if (userType !== USER_TYPE.externalUser) {
    isAuthenticated = useIsAuthenticated(); // Replace with your authentication logic
  }
  let isUserAuthenticated = false;
  if (isAuthenticationEnabled) {
    if (isAuthenticated) {
      isUserAuthenticated = true;
      if (sessionStorage.getItem('userActivity') !== 'true') {
        sessionStorage.setItem('userActivity', false);
      }
    } else {
      // Check if external user, skip MSAL authentication
      if (userType === USER_TYPE.externalUser) {
        let externalUserData = externalUserDetails() || [];
        if (externalUserData?.accessToken?.access_token === undefined) {
          if (!shouldLog.current) {
            shouldLog.current = true;
            fetchTokenAndUserData();
          }
          sessionStorage.setItem('userType', USER_TYPE.externalUser);
          if (sessionStorage.getItem('userActivity') !== 'true') {
            sessionStorage.setItem('userActivity', false);
          }
          sessionStorage.clear();
          isUserAuthenticated = true;
        } else {
          isUserAuthenticated = true;
        }
      }
    }
  } else {
    isUserAuthenticated = true;
  }
  const [restrictedRoute, setRestrictedRoute] = useState(null);
  const [intialRoute, setInitialRoute] = useState({
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/*',
        element: <Navigate to="/home" replace />,
      },
      {
        path: '/home',
        allowed: true,
        element: <HomePage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  });
  // const intialRoute = userType === USER_TYPE.internalUser ?  : ;

  const filterParentMenu = (children) => {
    let validPathAdded = [];
    children.filter((item) => {
      if (
        item.children.length > 0 ||
        item.path === '/' ||
        item.path === '/home'
      ) {
        validPathAdded.push(item);
      }
    });
    return validPathAdded;
  };

  const restrictRoutes = (AuthenticatedRoutes) => {
    const restrictedRoutesArray = AuthenticatedRoutes.map((route) => ({
      ...route,
      children: route?.children
        ?.map((child) => child)
        ?.map((child) => ({
          ...child,
          children:
            child?.children?.filter((child) => {
              if (getIsReadOnlyPermission(child?.featureName)) {
                return child;
              } else if (
                getIsReadOnlyPermission(child?.featureName) === undefined
              ) {
                if (
                  (child.path === 'AdminScreenRoles' ||
                    child.path === 'ETrackUserMCNMapping') &&
                  userPermissions?.userAuthorizations[0]?.roleName ===
                    CUSTOMERS.administratorRole
                ) {
                  return child;
                }
              }
            }) || [],
        })),
    }))?.filter((item) => {
      item.children = filterParentMenu(item?.children);
      return item;
    })[0];
    setRestrictedRoute(restrictedRoutesArray);
  };

  useEffect(() => {
    if (userPermissions) {
      if (userPermissions.userType === USER_TYPE.internalUser) {
        restrictRoutes(AuthenticatedRoutes);
      } else if (userPermissions.userType === USER_TYPE.externalUser) {
        restrictRoutes([ETrackRoutes]);
      }
    }
  }, [userPermissions]);

  return isUserAuthenticated
    ? useRoutes(
        restrictedRoute && userPermissions ? [restrictedRoute] : [intialRoute]
      )
    : useRoutes([LoginRoute]);
}
